import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';

import serviceIcon1 from '../../assets/img/service/icons/1.png';
import serviceIcon2 from '../../assets/img/service/icons/2.png';
import serviceIcon3 from '../../assets/img/service/icons/3.png';
import serviceIcon4 from '../../assets/img/service/icons/4.png';
import serviceIcon5 from '../../assets/img/service/icons/5.png';
import serviceIcon6 from '../../assets/img/service/icons/6.png';

const Service = () => {

    return (
        <div id="rs-service" className="rs-services main-home gray-bg pt-110 pb-120 md-pt-70 md-pb-70">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-46"
                    subtitleClass="sub-text"
                    subtitle="Services"
                    titleClass="title"
                    title="Transformative IT Solutions "
                    effectClass="heading-line"
                    description="We help businesses leverage technology to achieve their full potential"
                />
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon1}
                            serviceURL="software-development"
                            Title="Software Development" 
                            Text="Crafting innovative software solutions tailored to your unique business needs. Our expert developers leverage the latest technologies to deliver high-quality, scalable, and maintainable applications." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon2}
                            serviceURL="web-development"
                            Title="Web Development" 
                            Text="Building engaging and effective web experiences that drive results. From responsive websites to complex web applications, we create solutions that help achieve your business goals." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon3}
                            serviceURL="analytic-solutions"
                            Title="Analytic Solutions" 
                            Text="Transforming data into actionable insights. Our analytic solutions empower you to make informed decisions, optimize performance, and gain a competitive edge through data-driven strategies." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 md-mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon4}
                            serviceURL="clould-devOps"
                            Title="Cloud & DevOps" 
                            Text="Migrating, managing, and optimizing your infrastructure in the cloud. Our Cloud & DevOps expertise ensures scalability, reliability, and agility, allowing you to focus on innovation and growth." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 sm-mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon5}
                            serviceURL="product-design"
                            Title="Product & Design" 
                            Text="Creating user-centered products that delight and inspire. Our design and product teams collaborate to deliver intuitive, visually appealing, and impactful solutions that meet your business objectives." 
                            align="jutify"         
                                  />
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon6}
                            serviceURL="data-center"
                            Title="Managed Services" 
                            Text="Streamlining your IT operations with comprehensive managed services. We handle your IT applications, allowing you to focus on strategy, growth, and your core business." 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service;
